import { render } from "./Error.vue?vue&type=template&id=5ea2e2c7"
import script from "./Error.vue?vue&type=script&lang=js"
export * from "./Error.vue?vue&type=script&lang=js"
script.render = render

export default script